import realpressScheduleTour from './shortcode/schedule-tour/schedule-tour';

document.addEventListener( 'DOMContentLoaded', ( event ) => {
	realpressScheduleTour();
} );
